import { Link } from "react-router-dom";


const Header = () => {
	return (
// 		<>
// 		<header className="header d-flex justify-content-between align-items-center p-2 bg-dark">
	
// 	<div className="me-auto">
// 		<NavLink to="/" className="logo d-inline-block">
// 			<img
// 				src="/assets/img/BookOnNile Logo.svg"
// 				width={60}
// 				height={40}
// 				alt="Logo"
// 				style={{ background: "#fff", padding: "4px" }}
// 			/>
// 		</NavLink>
// 	</div>

	
// 	<div className="position-absolute start-50 translate-middle-x">
// 		<ul className="nav fs-6 gap-2 mb-0">
// 			<li className="nav-item">
// 				<NavLink
// 					to="/"
// 					className={({ isActive }) =>
// 						`nav-link text-white ${isActive ? 'active bg-warning' : ''}`
// 					}
// 				>
// 					Home
// 				</NavLink>
// 			</li>
// 			<li className="nav-item">
// 				<NavLink
// 					to="/PropertyLogin"
// 					className={({ isActive }) =>
// 						`nav-link text-white ${isActive ? 'active bg-warning' : ''}`
// 					}
// 				>
// 					Property
// 				</NavLink>
// 			</li>
// 			<li className="nav-item">
// 				<NavLink
// 					to="/Reservationlogin"
// 					className={({ isActive }) =>
// 						`nav-link text-white ${isActive ? 'active bg-warning' : ''}`
// 					}
// 				>
// 					Reservation
// 				</NavLink>
// 			</li>
// 			<li className="nav-item">
// 				<NavLink
// 					to="/agentlogin"
// 					className={({ isActive }) =>
// 						`nav-link text-white ${isActive ? 'active bg-warning' : ''}`
// 					}
// 				>
// 					Agent
// 				</NavLink>
// 			</li>
// 			<li className="nav-item">
// 				<NavLink
// 					to="/corporatelogin"
// 					className={({ isActive }) =>
// 						`nav-link text-white ${isActive ? 'active bg-warning' : ''}`
// 					}
// 				>
// 					Corporate
// 				</NavLink>
// 			</li>
// 		</ul>
// 	</div>
// </header>

// 		</>

<>


     {/* Header start */}
     
	 <div className="container-fluid bg-white px-0">
  <div className="row gx-0">
    <div className="col-lg-3 bg-white d-none d-lg-block">
      <a
        href="/"
        className="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center"
      >
        <img src="assets/img/BookOnNile Logo.svg" alt="/" className="p-2" style={{height:"auto",width:"6rem"}}/>
      </a>
    </div>
    <div className="col-lg-9">
      <nav className="navbar navbar-expand-lg bg-white navbar-dark p-3 p-lg-0" >
        <a href="/" className="navbar-brand d-block d-lg-none">
          <img src="assets/img/BookOnNile Logo.svg" alt="/" style={{height:"auto",width:"4rem"}}/>
        </a>
        <button
          type="button"
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div
          className="collapse navbar-collapse justify-content-between "
          id="navbarCollapse"
        >
          <div className="navbar-nav  py-0 p-3 m-3">
            <Link to="/Home" className="nav-item nav-link active mx-3 fw-bold">
              Home
            </Link>
            <Link to="/Property/Login" className="nav-item nav-link mx-3 fw-bold">
              Property
            </Link>
            <Link to="/Reservation/login" className="nav-item nav-link mx-3 fw-bold">
              Reservation
            </Link>
            <Link to="/Agent/login" className="nav-item nav-link mx-3  fw-bold">
              Agent
            </Link>
            <Link to="/CorporateLogin" className="nav-item nav-link mx-3 fw-bold">
              Corporate
            </Link>
          </div>

        </div>
      </nav>
    </div>
  </div>
</div>
	 {/* Header end */}

</>
	);
};

export default Header;
